export enum HashUpgradeEnum {
  SellForMoney = "Sell for Money",
  SellForCorporationFunds = "Sell for Corporation Funds",
  ReduceMinimumSecurity = "Reduce Minimum Security",
  IncreaseMaximumMoney = "Increase Maximum Money",
  ImproveStudying = "Improve Studying",
  ImproveGymTraining = "Improve Gym Training",
  ExchangeForCorporationResearch = "Exchange for Corporation Research",
  ExchangeForBladeburnerRank = "Exchange for Bladeburner Rank",
  ExchangeForBladeburnerSP = "Exchange for Bladeburner SP",
  GenerateCodingContract = "Generate Coding Contract",
  CompanyFavor = "Company Favor",
}
